import { RepositorioBaseComFiltragemDeLeitura } from "@/http"
import {
  CriarProfissional,
  ListarProfissionais,
  ListarProfissionaisSimples,
  ParamsProfissional,
} from "./profissional.modelo"
import { Anulavel } from "@/types/gerais"
import { ResultadoApiGET } from "@/types/api"

class ProfissionalRepositorio extends RepositorioBaseComFiltragemDeLeitura {
  public listarProfissionais = <T = string>(
    params?: ParamsProfissional
  ): Promise<ResultadoApiGET<ListarProfissionaisSimples<T>>> =>
    this.instance.get("/api/profissionais", { params })

  public listarProfissionaisFrontend = <T = string>(
    params?: ParamsProfissional
  ): Promise<ResultadoApiGET<ListarProfissionais<T>>> =>
    this.instance.get("/api/frontend/profissionais", { params })

  public criarProfissionalComUsuario = (
    profissional?: CriarProfissional
  ): Promise<{ id: string }> =>
    this.instance.post("/api/profissionais/com-usuario", profissional)

  public criarProfissionalSemUsuario = (
    profissional?: CriarProfissional
  ): Promise<{ id: string }> =>
    this.instance.post("/api/profissionais", profissional)

  public atualizarProfissionalSemUsuario = (
    id?: string,
    profissional?: CriarProfissional
  ): Promise<{ id: string }> =>
    this.instance.patch(`/api/profissionais/${id}`, profissional)

  public atualizarProfissionalComUsuario = (
    id?: string,
    profissional?: CriarProfissional
  ): Promise<{ id: string }> =>
    this.instance.patch(`/api/profissionais/${id}/com-usuario`, profissional)

  public obterFotoProfissional = (urlImagem: string): Promise<string> => {
    return this.instance.get(`/api/profissionais/foto/${urlImagem}`, {
      responseType: "arraybuffer",
    })
  }

  public atualizarFotoProfissional = (
    id?: string,
    profissional?: FormData
  ): Promise<{ id: string }> =>
    this.instance.patch(`/api/profissionais/${id}/foto`, profissional, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })

  public arquivarProfissional = (id?: string): Promise<{ id: string }> =>
    this.instance.post("/api/profissionais/" + id + "/desativar")

  public desarquivarProfissional = (id?: string): Promise<{ id: string }> =>
    this.instance.post("/api/profissionais/" + id + "/ativar")

  public deletarProfissional = (id: Anulavel<string>): Promise<void> =>
    this.instance.delete("/api/profissionais/" + id)
}

export default ProfissionalRepositorio
